var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pleasenote foldtl",class:{ 'float-right': _vm.float === 'right', 'float-left': _vm.float === 'left' }},[_c('strong',[_vm._t("label",function(){return [_vm._v("Please Note:")]})],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }